import { render, staticRenderFns } from "./MomentTabHeader.vue?vue&type=template&id=5817235e&scoped=true&"
import script from "./MomentTabHeader.vue?vue&type=script&lang=js&"
export * from "./MomentTabHeader.vue?vue&type=script&lang=js&"
import style0 from "./MomentTabHeader.vue?vue&type=style&index=0&id=5817235e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5817235e",
  null
  
)

export default component.exports